var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36997 22.23C5.24997 22.23 4.53997 21.85 4.08997 21.4C3.20997 20.52 2.58997 18.65 4.56997 14.68L5.43997 12.95C5.54997 12.72 5.54997 12.24 5.43997 12.01L4.56997 10.28C2.57997 6.31 3.20997 4.43 4.08997 3.56C4.95997 2.68 6.83997 2.05 10.8 4.04L19.36 8.32C21.49 9.38 22.66 10.86 22.66 12.48C22.66 14.1 21.49 15.58 19.37 16.64L10.81 20.92C8.86997 21.89 7.42997 22.23 6.36997 22.23ZM6.36997 4.23C5.82997 4.23 5.40997 4.36 5.14997 4.62C4.41997 5.34 4.70997 7.21 5.90997 9.6L6.77997 11.34C7.09997 11.99 7.09997 12.97 6.77997 13.62L5.90997 15.35C4.70997 17.75 4.41997 19.61 5.14997 20.33C5.86997 21.06 7.73997 20.77 10.14 19.57L18.7 15.29C20.27 14.51 21.16 13.48 21.16 12.47C21.16 11.46 20.26 10.43 18.69 9.65L10.13 5.38C8.60997 4.62 7.29997 4.23 6.36997 4.23Z",
    fill: "#0077D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 13.23H6.39996C5.98996 13.23 5.64996 12.89 5.64996 12.48C5.64996 12.07 5.98996 11.73 6.39996 11.73H11.8C12.21 11.73 12.55 12.07 12.55 12.48C12.55 12.89 12.21 13.23 11.8 13.23Z",
    fill: "#0077D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.09084f15a9c8438b240b28ab29057072.svg";
export { ForwardRef as ReactComponent };